/* Rapport de rétention — RJ-09 (Bible §28/§55).
   Mature cohorts only, per the denominator rule: a customer whose next
   eligibility has not yet matured is not a customer who failed to return.
   Same-session resumes are excluded; delay and unavailability fallbacks are
   counted separately rather than folded into the return rate. */
import { Button, EmptyState, ErrorState, Tile, Tiles } from '@/ui'
import { useRetention } from './api'
import { Chargement, Retour } from './parts'

export default function Retention() {
  const { data, isPending, isError, refetch } = useRetention()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger le rapport."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  if (data.rows.length === 0) return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 640 }}>
      <Retour />
      <EmptyState title="Aucune cohorte mûre pour l’instant."
        why="Le rapport n’ouvre qu’une fois l’éligibilité suivante arrivée à terme pour un premier groupe de clients — avant cela, un taux de clients revenus ne voudrait rien dire." />
    </div>
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 800 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-page" style={{ margin: 0 }}>Rapport de rétention</h2>
        <span className="f-help" style={{ marginLeft: 'auto' }}>cohortes mûres · Europe/Paris</span>
      </div>

      <Tiles>
        <Tile label="Cohorte qualifiée" value={data.cohort} hint="éligibilité suivante mûrie" />
        <Tile label="Clients revenus (cohorte mûre)" value={data.matureReturnRate} hint="déf. §55 · 90 j" />
        <Tile label="Jours médians" value={data.medianDays} hint="entre participations" />
      </Tiles>

      <div className="tablewrap">
        <table className="tbl">
          <thead><tr><th>Étape</th><th>Atteinte</th><th>Chute</th><th>Utilisation cadeau</th></tr></thead>
          <tbody>
            {data.rows.map(r => (
              <tr key={r.stage}>
                <td>{r.stage}</td><td>{r.reach}</td><td>{r.drop}</td><td>{r.giftUse}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="f-help" style={{ margin: 0 }}>
        Reprises même session exclues des retours. Repli délai/indisponibilité comptés séparément.
      </p>
    </div>
  )
}
